/**
 * ---------------------------------------------------------------------------
 * NCJ COMPONENT: Async Loader
 * FILE: ncj-async-loader.js
 * PURPOSE: Fires 'startasyncloading' / 'StartAsyncLoading' custom events
 *          on first user interaction (or after 9 s fallback). Third-party
 *          scripts (Sufio VAT, vital-loader, header, footer) listen for
 *          this event to begin loading. Formerly 'custom.min.js'.
 * AUTHOR: No Code Jungle (NCJ)
 * LAST MODIFIED: 2026-03-23
 * ---------------------------------------------------------------------------
 */

var ncjAsyncLoaded = false;

function ncjLoadAsync() {
  if (ncjAsyncLoaded) return;
  ncjAsyncLoaded = true;

  if (typeof observers !== 'undefined' && observers.disconnect) {
    observers.disconnect();
  }

  document.dispatchEvent(new CustomEvent('startasyncloading'));
  document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
}

['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart',
 'click', 'keypress', 'touchmove', 'pointerdown', 'wheel'
].forEach(function (evt) {
  window.addEventListener(evt, ncjLoadAsync, { once: true, passive: true });
});

/* Fallback: fire after 9 seconds if no user interaction */
window.addEventListener('load', function () {
  setTimeout(function () {
    if (!ncjAsyncLoaded) ncjLoadAsync();
  }, 9000);
});
